import { useContext } from "react"

import { RecordContext } from "web/contexts"
import { useFieldValue } from "web/hooks/data"

import { formatValue, getCurrencySymbol } from "web/services/format"
import { isAValue } from "web/services/helpers"

export default function ValueInfo({ fieldKey }) {
  const recordContext = useContext(RecordContext)

  const [fieldValue] = useFieldValue({
    subjectType: recordContext.resource_type,
    topicId: recordContext.topic_id,
    recordId: recordContext.id,
    fieldKey,
  })

  const { legacy_value_info } = fieldValue

  return legacy_value_info.map((infoItem, index) => {
    if (infoItem.type === "unit") {
      return <UnitInfo key={index} {...infoItem} />
    } else if (infoItem.type === "source") {
      return <SourceInfo key={index} {...infoItem} />
    } else {
      return null
    }
  })
}

function UnitInfo({ value }) {
  const showUnitLabel =
    value.kind === "Money" && getCurrencySymbol(value.unit) !== value.unit
  const unitLabel = showUnitLabel ? ` ${value.unit}` : ""
  return <div>{`Entered as ${formatValue(value)}${unitLabel}`}</div>
}

function SourceInfo({ value, source_name }) {
  const showUnit = value.kind === "Money" && isAValue(value.unit)
  const formattedValue = Array.isArray(value)
    ? value.map((v) => formatValue(v)).join(", ")
    : formatValue(value)

  return (
    <div>
      <span className="font-bold">
        {`${formattedValue}${showUnit ? ` ${value.unit}` : ""}`}
      </span>
      <span>{` per ${source_name}`}</span>
    </div>
  )
}
